import * as styles from "../../../../../styles/WholedataPage";
import React, { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../store";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../reducer/index";
import { LoadFarm } from "../../../../../reduxaction/post";
import { Outersensors } from "../../../../../reducer/postpayloadtypes";
import { useLocation, useNavigate } from "react-router-dom";
import axios from 'axios';

const Environment = ({ data }: { data: any }) => {
  const navigate = useNavigate();

  const { TargetDiary, Farms, Targetfarms, TargetInsectContainer } =
    useSelector((state: RootState) => state.post);

  const { name, placeId, idx } = data;

  let [OpenEnv, setOpenEnv] = useState(true);
  let boxlist: any = [];
  let targetcontainer: any; // 현재 컨테이너 데이터

  const [sensordata, setSensordata] = useState([]);
  const [outersensor, setOutersensordata] = useState([]);
  const [Insensor, setInsensordata] = useState([]);
  const [section, setSectiondata] = useState([]);
  // const [boxlist, setBox] = useState<{ boxName: string; manageBoxId: number; instar: string; }[]>([]);
  const [boxsensor, setBoxsensor] = useState([]);

  boxlist.push({
    name: name,
    boxId: placeId,
    idx: idx,
    // instar: instar,
  });
  // console.log("TargetInsectContainer", TargetInsectContainer);
  Targetfarms?.children.map((Obj, idx) => {
    if (Obj.name === TargetInsectContainer) {
      targetcontainer = Obj;
    }
  });

  // console.log("targetcontainer", targetcontainer);

  // Targetfarms?.children.map((Obj, idx) => {
  //   if (Obj.name === TargetInsectContainer) {
  //     targetcontainer = Obj;
  //     Obj.children.map((item, idx) => {
  //       boxlist.push({
  //         name: item.name,
  //         boxId: item.placeId,
  //         instar: item.instar,
  //       });
  //     });
  //   }
  // });

  // useEffect(() => {
  //   dispatch(LoadFarm());
  // }, []);

  // 외기 센서
  useEffect(() => {
    const searchSensor = async () => {

      // console.log(localStorage.getItem("targetfarm"));
      const targetdata = localStorage.getItem("targetfarm");
      try {
        const response = await axios.get(`/ifactory/api/diarytag?placeId=${placeId}`);
        // const response = await axios.get(`/ifactory/api/place`);
        // console.log("response", response.data);
        const results = response.data;
        console.log("Env results :: ", results);

        // 농장
        if (results[0]?.equips[0]?.sensors) {
          setOutersensordata(results[0].equips[0].sensors);
        }
        // 사육실
        if (results[1]?.equips[0]?.sensors) {
          setInsensordata(results[1].equips[0].sensors);
        }
        // 구역
        if (results[2]?.equips[0]?.sensors) {
          setSectiondata(results[2].equips[0].sensors);
        }
        // 박스
        if (results[3]?.equips[0]?.sensors) {
          setBoxsensor(results[3].equips[0].sensors);
        }

        // setInsensordata(results[0].equips[0].sensors);
        // setInsensordata(targetcontainer.equips[0].sensors);

      } catch (error: any) {
        console.error(error);
      }
    };
    searchSensor();
  }, [placeId]);

  // 박스선택하기 상자 조회
  const location = useLocation();
  useEffect(() => {
    const searchBox = async () => {

      const selectedPlaceId = location.state.selectedPlaceId;
      console.log("selectedPlaceId", selectedPlaceId);

      try {
        const response = await axios.get(`/ifactory/api/place/insect/boxes?placeId=${selectedPlaceId}&type=CONTAINER`);
        console.log("상자 조회 response", convertToArray(response.data));
        // setBox(convertToArray(response.data));
      } catch (error) {
        // 오류 처리
      }
    };

    // 페이지 로딩 시에 실행
    searchBox();
  }, []);

  const convertToArray = (data: any[]) => {
    return Object.entries(data).map(([key, value]) => {
      return value.map((item: any) => ({
        name: item.name,
        placeId: item.placeId,
      }));
    }).flat();
  };

  // const outersensor = sensordata; //Targetfarms?.equips[0]?.sensors;
  // 사육실 내부 환경정보
  // const Insensor = targetcontainer?.equips[0]?.sensors;

  // 상자 환경 정보
  // const boxsensor = targetcontainer?.children;

  let [sensorboxitem, setsensorboxitem] = useState(0);

  const boxchange = (boxname: any, idx: any) => {
    setsensorboxitem(idx);
  };

  return (
    <styles.EnvironmentalCon>
      <styles.Environmentaltit>
        <p className="content-tit">환경정보</p>
        <p>
          <img
            src="./img/ArrowTop.svg"
            className={OpenEnv === false ? "rotate" : ""}
            onClick={() => {
              setOpenEnv(!OpenEnv);
            }}
          />
        </p>
      </styles.Environmentaltit>



      <styles.EnvironmentalHide className={OpenEnv === false ? "hide" : ""}>

        {outersensor && outersensor.length > 0 && (
          <styles.EnvironmentalBox>
            <p className="EnvironmentalBox-tit Spoqa500">
              <span className="c-22c197 Spoqa500">외기</span> 환경정보
            </p>
            <styles.OutsideAirList>
              {outersensor &&
                outersensor.map((sensor: any, idx: number) => {
                  const windParser = (sensors: Outersensors) => {
                    let value = sensors?.value;

                    if (
                      (value >= "0" && value <= "22.5") ||
                      (value > "337.5" && value <= "360")
                    ) {
                      return "북";
                    }
                    if (value > "22.5" && value <= "67.5") return "북동풍";
                    if (value > "67.5" && value <= "112.5") return "동풍";
                    if (value > "112.5" && value <= "157.5") return "남동풍";
                    if (value > "157.5" && value <= "202.5") return "남풍";
                    if (value > "202.5" && value <= "247.5") return "남서풍";
                    if (value > "247.5" && value <= "292.5") return "서풍";
                    if (value > "292.5" && value <= "337.5") return "북서풍";

                    return "NO DATA";
                  };

                  const snsrControl = (sensors: any) => {
                    let res = "";

                    // switch (sensors?.tagClass.code) {
                    //   case "RAINCHECK":
                    //     res = sensors?.value === "1" ? "비" : "비 안옴";
                    //     break;
                    //   case "WINDDIR":
                    //     res = windParser(sensors);
                    //     break;
                    //   default:
                    //     res = sensors?.value?.toString();
                    // }

                    return res;
                  };

                  return (
                    <styles.OutsideAirListItem key={sensor?.tagId}>
                      <p className="outsideair-item-tit">{sensor?.name}</p>
                      <p className="outsideair-item-content">
                        {sensor.value}
                        {/* {snsrControl(sensor)} */}
                        {sensor?.tagClass?.unit}
                      </p>
                    </styles.OutsideAirListItem>
                  );
                })}
            </styles.OutsideAirList>
          </styles.EnvironmentalBox>
        )}

        {Insensor && Insensor.length > 0 && (
          <styles.EnvironmentalBox>
            <p className="EnvironmentalBox-tit Spoqa500">
              <span className="c-22c197 Spoqa500">사육실</span> 내부 환경정보
            </p>
            <styles.EnvironmentalGrap>
              {/* <styles.EnvironmentSample>
              <div className="item">
                <p className="sample bg-22C197"></p>
                <p className="text">정상</p>
              </div>
              <div className="item">
                <p className="sample"></p>
                <p className="text">위험</p>
              </div>
            </styles.EnvironmentSample> */}
              {Insensor &&
                Insensor.map((sensor: any, idx: Number) => {
                  let sensorcolor = "";
                  let fontcolor = "";

                  sensorcolor = "bg-22C197";
                  fontcolor = "22C197";

                  if (
                    sensor.value >= sensor.tagRange.alarmLowerLimit &&
                    sensor.value <= sensor.tagRange.alarmUpperLimit
                  ) {
                    sensorcolor = "bg-22C197";
                    fontcolor = "22C197";
                  } else {
                    sensorcolor = "bg-FF0000";
                    fontcolor = "FF0000";
                  }

                  return (
                    <styles.EnvironmentalItem key={sensor?.tagId}>
                      <p className="env-item-title">{sensor?.name}</p>
                      <p className={`env-item-color `}>
                        <p className={`${sensorcolor}`}></p>
                      </p>
                      <p className={`env-item-value color-${fontcolor}`}>
                        {sensor?.value}
                        {sensor?.tagClass.unit}
                      </p>
                    </styles.EnvironmentalItem>
                  );
                })}
            </styles.EnvironmentalGrap>
          </styles.EnvironmentalBox>
        )}

        {section && section.length > 0 && (
          <styles.EnvironmentalBox>
            <p className="EnvironmentalBox-tit Spoqa500">
              <span className="c-22c197 Spoqa500">사육구역</span> 내부 환경정보
            </p>
            <styles.EnvironmentalGrap>
              {/* <styles.EnvironmentSample>
                <div className="item">
                  <p className="sample bg-22C197"></p>
                  <p className="text">정상</p>
                </div>
                <div className="item">
                  <p className="sample"></p>
                  <p className="text">위험</p>
                </div>
              </styles.EnvironmentSample> */}
              {section &&
                section.map((sensor: any, idx: Number) => {
                  let sensorcolor = "";
                  let fontcolor = "";

                  sensorcolor = "bg-22C197";
                  fontcolor = "22C197";

                  if (
                    sensor.value >= sensor.tagRange.alarmLowerLimit &&
                    sensor.value <= sensor.tagRange.alarmUpperLimit
                  ) {
                    sensorcolor = "bg-22C197";
                    fontcolor = "22C197";
                  } else {
                    sensorcolor = "bg-FF0000";
                    fontcolor = "FF0000";
                  }

                  return (
                    <styles.EnvironmentalItem key={sensor?.tagId}>
                      <p className="env-item-title">{sensor?.name}</p>
                      <p className={`env-item-color `}>
                        <p className={`${sensorcolor}`}></p>
                      </p>
                      <p className={`env-item-value color-${fontcolor}`}>
                        {sensor?.value}
                        {sensor?.tagClass.unit}
                      </p>
                    </styles.EnvironmentalItem>
                  );
                })}
            </styles.EnvironmentalGrap>
          </styles.EnvironmentalBox>
        )}


        {boxsensor && boxsensor.length > 0 && (
          <styles.EnvironmentalBox>
            <p className="EnvironmentalBox-tit Spoqa500">
              <span className="c-22c197 Spoqa500">사육상자</span> 내부 환경정보
            </p>

            {/*          
          <styles.BreedingBoxBot>
            {boxlist && boxlist[0].name !== null &&
              boxlist.map((box: any, idx: any) => {
                let instarcolor = "";

                switch (box.instar) {
                  case "EGG":
                    instarcolor = "#feca0a";
                    break;
                  case "IMAGO":
                    instarcolor = "#b96730";
                    break;
                  case "PUPA":
                    instarcolor = "#afaad3";
                    break;
                  case "LARVA":
                    instarcolor = "#8bc63e";
                    break;
                  default:
                    instarcolor = "lightgray";
                }

                return (
                  <p
                    key={idx}
                    className={
                      sensorboxitem === idx
                        ? "breedingbox-active"
                        : "breedingbox"
                    }
                    onClick={() => boxchange(box?.name, idx)}
                    style={{
                      background:
                        sensorboxitem === idx ? "#2a3a4b" : instarcolor,

                      color: "white",
                      width: 'auto',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {box?.name}
                  </p>
                );
              })}
          </styles.BreedingBoxBot>
           */}



            <styles.EnvironmentalGrap>
              {/* <styles.EnvironmentSample>
                <div className="item">
                  <p className="sample bg-22C197"></p>
                  <p className="text">정상</p>
                </div>
                <div className="item">
                  <p className="sample"></p>
                  <p className="text">위험</p>
                </div>
              </styles.EnvironmentSample> */}
              {boxsensor?.map(
                (boxsensor: any, idx: Number) => {
                  let sensorcolor = "";
                  let fontcolor = "";

                  if (
                    boxsensor.value >= boxsensor.tagRange.alarmLowerLimit &&
                    boxsensor.value <= boxsensor.tagRange.alarmUpperLimit
                  ) {
                    sensorcolor = "bg-22C197";
                    fontcolor = "22C197";
                  } else {
                    sensorcolor = "bg-FF0000";
                    fontcolor = "FF0000";
                  }

                  return (
                    <styles.EnvironmentalItem key={boxsensor.tagId}>
                      <p className="env-item-title">{boxsensor.name}</p>
                      <p className={`env-item-color `}>
                        <p className={`${sensorcolor}`}></p>
                      </p>
                      <p className={`env-item-value color-${fontcolor}`}>
                        {boxsensor.value}
                        {boxsensor.tagClass.unit}
                      </p>
                    </styles.EnvironmentalItem>
                  );
                }
              )}
            </styles.EnvironmentalGrap>
          </styles.EnvironmentalBox>

        )}

      </styles.EnvironmentalHide>
    </styles.EnvironmentalCon>
  );
};

export default Environment;
function dispatch(arg0: any) {
  throw new Error("Function not implemented.");
}
